import Reveal from '@/components/base/Reveal';
import SectionHeading from '@/components/base/SectionHeading';
import Counter from '@/components/base/Counter';
import { heroStats, whyWeGuarantee } from '@/mocks/strategix';

const guaranteeStats = heroStats.filter((stat) => stat.label !== 'подписчиков привлекли');

export default function WhyWeGuarantee() {
  return (
    <section className="relative w-full px-5 md:px-10 pt-16 md:pt-20 pb-20 md:pb-28">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          label="Почему мы гарантируем результат"
          title="Наш результат предсказуем, а не случаен"
          description="Цифры в тарифах — это не обещание «на удачу», а следствие системы, проверенной на 240+ сообществах. Рассказываем, на чём держится наша уверенность и почему вы можете на неё опираться."
        />

        {/* Stats */}
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {guaranteeStats.map((stat, index) => (
            <Reveal key={stat.label} delay={index * 80}>
              <div className="p-6 rounded-lg bg-background-100/70 border border-background-200/70">
                <div className="font-heading font-bold text-3xl md:text-4xl text-foreground-950">
                  <Counter value={stat.value} suffix={stat.suffix} />
                </div>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{stat.label}</p>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Reasons */}
        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {whyWeGuarantee.map((item, index) => (
            <Reveal key={item.title} delay={index * 70} className="h-full">
              <div className="h-full p-6 rounded-lg bg-background-100/70 border border-background-200/70 hover:border-primary-400/60 transition-colors">
                <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                  <i className={`${item.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-5 font-heading text-base md:text-lg text-foreground-950">{item.title}</h3>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{item.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={150}>
          <p className="mt-12 max-w-3xl mx-auto text-center text-sm md:text-base text-foreground-700 leading-relaxed">
            Именно поэтому мы готовы фиксировать KPI в договоре и отвечать за них рублём:
            если бюджет не израсходован — возвращаем остаток, а отчётность показываем каждую неделю.
            Гарантия для нас — не маркетинг, а рабочий инструмент доверия.
          </p>
        </Reveal>
      </div>
    </section>
  );
}